module.exports = __webpack_public_path__ + "img/pic_S3@2x.712835a9.png";